module.exports = __webpack_public_path__ + "media/images/book-and-ball-26b9ab17239a97571532017ace0d4982.png";